"use client";

import { ActionCard } from "./ActionCard";
import { parseActionsFromMessage } from "@/lib/actions";

export function ActionMessage({
  text,
  sessionId,
}: {
  text: string;
  sessionId: string | null;
}) {
  const parsed = parseActionsFromMessage(text);

  return (
    <article aria-label="Assistant message" className="flex w-full justify-start">
      <div className="max-w-[80%] flex flex-col gap-2">
        {parsed.segments.map((seg, i) =>
          seg.kind === "prose" ? (
            <div
              key={i}
              className="rounded-xl border border-[var(--border-subtle)] px-3 py-2 text-[15px] leading-6 text-[var(--text-primary)]"
            >
              {seg.text.split("\n").map((line, j) => (
                <p key={j} className={j > 0 ? "mt-2" : ""}>
                  {line}
                </p>
              ))}
            </div>
          ) : (
            <ActionCard key={i} action={seg.action} sessionId={sessionId} />
          ),
        )}
        {parsed.errors.length > 0 && (
          <div className="text-[12px] text-[var(--status-warning)]">
            Skipped {parsed.errors.length} malformed action block{parsed.errors.length > 1 ? "s" : ""}.
          </div>
        )}
      </div>
    </article>
  );
}
